<div id="headerComponentContainerFull">
  <header
    [attr.data-type]="dataType"
    [attr.data-login-destination-url]="dataLoginDestinationUrl"
    [attr.data-limited]="false">
  </header>
</div>
